export const emailInfo = {
    EMAIL_SUCCESS_TEXT: `The result has been successfully sent to your email. Please make sure to check your spam or junk folders.`,
    EMAIL_TYPE: 'RESULT_TEMPLATE'
};
